























































































import Vue from 'vue';

export default Vue.extend({
    name: 'Help',
    created() {
        this.$store.state.routeLoaded = true;
    }
})
